import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { callAPI } from "../feature/APISlice";
import AdminNavbar from "./AdminNavbar";
import "./css/VolunteerList.css";

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/forms-data/contact-us`;

export default function ContactusList() {
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((s) => s.api);

  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");

  useEffect(() => {
    dispatch(callAPI({ method: "get", url: BASE_URL }));
  }, [dispatch]);

  const filteredData = useMemo(() => {
    let data = [...items];

    if (search) {
      data = data.filter((v) =>
        [v.name, v.email, v.phoneNumber]
          .join(" ")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }
    data.sort((a, b) => {
      if (sortOrder === "desc") {
        return new Date(b.createdTime) - new Date(a.createdTime);
      }
      return new Date(a.createdTime) - new Date(b.createdTime);
    });

    return data;
  }, [items, search, sortOrder]);

  return (
    <div>
      <AdminNavbar />

     <div className="customcontainer">
         <div className="pf-container">
        
        <div className="pf-toolbar">
          <input
            className="pf-input"
            placeholder="Search name, email, phone..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <select
            className="pf-input"
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
          >
            <option value="desc">Latest First</option>
            <option value="asc">Oldest First</option>
          </select>
        </div>

        {loading && <p>Loading...</p>}
        {error && <p className="error-text">{error}</p>}

        
        <div className="pf-table-wrapper">
          <table className="pf-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Message</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {filteredData.length === 0 && (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No records found
                  </td>
                </tr>
              )}

              {filteredData.map((v, i) => (
                <tr key={v.id}>
                  <td>{i + 1}</td>
                  <td className="pf-name">{v.name}</td>
                  <td>{v.email}</td>
                  <td>{v.phoneNumber}</td>
                  <td className="pf-address">{v.message}</td>
                  <td>
                    <span
                      className={
                        v.is_active
                          ? "pf-status pf-active"
                          : "pf-status pf-inactive"
                      }
                    >
                      {v.is_active ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td>
                    {new Date(v.createdTime).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
     </div>
    </div>
  );
}
